// extracted by mini-css-extract-plugin
var _1 = "RfelskfMK8kgE3uZofZk";
var _2 = "pMq92R47w9MzUFk3pT9d";
var _3 = "TFyHMtF7UeOdJUJcqm5E";
var _4 = "ZYu_e_JKOsyTg97QRrJa";
var _5 = "_mMTCnvnOX9REbTsnckK";
export { _1 as "close", _2 as "container", _3 as "header", _4 as "option", _5 as "title" }
